import { TranslateConversationArgs } from 'types/api/arguments/translate-conversation-args'
import { TranslateConversationResp } from 'types/api/response/translate-conversation-resp'

import { api } from './api'

export const translateConversation = ({ conversationId, translate }: TranslateConversationArgs) =>
  api.put<TranslateConversationResp>(`/conversations/${conversationId}/translation`, {
    translate,
  })
